import { __decorate } from "tslib";
import { Component } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { SharedHttp } from "../../../services/http-client.service";
let DeactivateDcaComponent = class DeactivateDcaComponent {
    constructor(sanitizer, location, themeService, httpClient) {
        this.sanitizer = sanitizer;
        this.location = location;
        this.themeService = themeService;
        this.httpClient = httpClient;
        this.borderRadiusLarger = '';
        this.borderRadiusSmaller = '';
        this.deactivateDcaButtonClicked = false;
        this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    deactivateDca() {
        this.deactivateDcaButtonClicked = true;
        this.httpClient.post('dca/deactivateDca', { dca_id: this.data.dca_id }).subscribe(data => {
            this.deactivateDcaButtonClicked = false;
            this.close();
            this.success();
        }, error => {
            this.deactivateDcaButtonClicked = false;
        });
    }
};
DeactivateDcaComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: SharedHttp }
];
DeactivateDcaComponent = __decorate([
    Component({
        selector: 'app-deactivate-dca',
        template: __importDefault(require("./deactivate-dca.component.html")).default,
    })
], DeactivateDcaComponent);
export { DeactivateDcaComponent };
